import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useUIStore = defineStore('ui', () => {
  const activePage = ref('overview');
  const sidebarCollapsed = ref(false);
  const chatPanelOpen = ref(false);
  const mobileMenuOpen = ref(false);
  const isMobile = ref(false);
  const theme = ref('dark');

  function setActivePage(page) {
    activePage.value = page;
  }

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }

  function toggleChatPanel() {
    chatPanelOpen.value = !chatPanelOpen.value;
  }

  function openMobileMenu() {
    mobileMenuOpen.value = true;
  }

  function closeMobileMenu() {
    mobileMenuOpen.value = false;
  }

  function toggleMobileMenu() {
    mobileMenuOpen.value = !mobileMenuOpen.value;
  }

  function setMobile(value) {
    isMobile.value = value;
    if (!value) {
      mobileMenuOpen.value = false;
    }
  }

  function setTheme(newTheme) {
    theme.value = newTheme;
    document.documentElement.setAttribute('data-theme', newTheme);
  }

  const sidebarClass = computed(() => ({
    'sidebar-collapsed': sidebarCollapsed.value,
    'sidebar-mobile': isMobile.value && mobileMenuOpen.value,
  }));

  return {
    activePage,
    sidebarCollapsed,
    chatPanelOpen,
    mobileMenuOpen,
    isMobile,
    theme,
    setActivePage,
    toggleSidebar,
    toggleChatPanel,
    openMobileMenu,
    closeMobileMenu,
    toggleMobileMenu,
    setMobile,
    setTheme,
    sidebarClass,
  };
});
